<template>

    <Push
    :crossIcon="false"
    width="250"
    noOverlay
    @openMenu="handleOpen"
    @closeMenu="handleClose">

        <nav-item
        :internalLink="true"
        title="Home"
        text="See featured work"
        emoji="eyes"
        path="/" />

        <nav-item
        :internalLink="true"
        title="About"
        text="Info, skills, and resume"
        emoji="danaraujo"
        path="/about" />

        <nav-item
        :internalLink="true"
        title="Work"
        text="See all projects"
        emoji="computer"
        path="/projects" />

        <nav-item
        :internalLink="false"
        title="Email"
        text="Let's talk"
        emoji="envelope"
        path="mailto:dancaraujo@gmail.com" />

        <nav-item
        :internalLink="false"
        title="Linkedin"
        text="Connect with me"
        emoji="handshake_hmn_y2"
        path="https://www.linkedin.com/in/dancaraujo"
        target="_blank"/>

    </Push>

</template>

<script>
import { Push } from 'vue-burger-menu'
import anime from 'animejs'
import NavItem from './nav/NavItem.vue'

export default {

  components: { Push, NavItem },
  data () {
    return {
    }
  },
  methods: {
    handleOpen () {
      this.animateButton(500, 250, 'none', 1)
      document.querySelector('#overlay').style.display = 'block'
      document.querySelector('body').style.overflowY = 'hidden'
      document.querySelector('#page-wrap').style.transition = 'all 0.5s ease 0s'
    },
    handleClose () {
      this.animateButton(500, 0, 'auto', 0)
      setTimeout(() => {
        document.querySelector('#overlay').style.display = 'none'
        document.querySelector('body').style.overflowY = 'auto'
        document.querySelector('#page-wrap').style.transition = 'none'
      }, 500)
    },
    animateButton (duration, translateX, pointerEvents, opacity) {
      anime.remove('.bm-burger-button')
      anime.remove('#overlay')

      anime({
        targets: '.bm-burger-button',
        translateX: translateX,
        rotate: [90, 90],
        duration: duration,
        easing: 'cubicBezier(0.25, 0.1, 0.25, 1)'
      })

      anime({
        targets: '#overlay',
        opacity: opacity,
        duration: duration,
        easing: 'easeOutQuad'
      })

      anime.set('.bm-burger-button', {
        pointerEvents: pointerEvents,
        rotate: 90
      })
    }
  },
  mounted () {
    this.animateButton(1, 0, 'auto', 0)

    setTimeout(() => {
      document.querySelector('.bm-burger-button').removeAttribute('style')
    }, 10)
  }

}
</script>

<style lang="scss">

#app {
  .bm-burger-button {
      text-decoration: none;
      user-select: none;
      display: flex;
      align-items: center;
      height: 52px;
      background-color: $gray8;
      position: fixed;
      z-index: 999;
      width: auto;
      top: 0;
      left: 0;
      cursor: pointer;
      box-shadow: 0px 42px $gray8;
      transition: background-color 200ms ease-out;

      -webkit-backface-visibility: hidden;
      transform: translateZ(0) scale(1.0, 1.0) rotate(90deg);
      transform-origin: bottom left;
      top: -52px;

      &:after {
          content: 'DA';
          color: $white;
          text-transform: uppercase;
          font-family: $display-font;
          font-size: 32px;
          line-height: 36px;
          z-index: 1;
          position: relative;
          padding: 8px 46px 8px 16px;
          outline: none;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          background-image: url('data:image/svg+xml;charset=UTF-8, <svg width="52" height="52" viewBox="0 0 52 52" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M44 20V17H13L14 20H44Z" fill="white"/><path d="M40 29V26H16L17 29H40Z" fill="white"/><path d="M44 38V35H19L20 38H44Z" fill="white"/></svg>');
          background-repeat: no-repeat;
          background-position: 40px;
      }

      &:hover {
          background-color: $gray7;

      }
  }

  .bm-burger-bars {
      background-color: $white;
      display: none;
  }

  .bm-menu {
      overflow: hidden;
      padding: 0;
  }

  .bm-item-list {
      color: inherit;
      font-size: inherit;
      margin: 0;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: stretch;
      height: 100vh;
  }

  .bm-item-list > * {
      padding: 0;
  }
}

.nav-link {

    &:nth-of-type(1) {
        background-image: url("data:image/svg+xml,%3Csvg width='42' height='44' viewBox='0 0 42 44' xmlns='http://www.w3.org/2000/svg'%3E%3Cg id='Page-1' fill='none' fill-rule='evenodd'%3E%3Cg id='brick-wall' fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M0 0h42v44H0V0zm1 1h40v20H1V1zM0 23h20v20H0V23zm22 0h20v20H22V23z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }

    &:nth-of-type(2) {
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40'%3E%3Cg fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M0 38.59l2.83-2.83 1.41 1.41L1.41 40H0v-1.41zM0 1.4l2.83 2.83 1.41-1.41L1.41 0H0v1.41zM38.59 40l-2.83-2.83 1.41-1.41L40 38.59V40h-1.41zM40 1.41l-2.83 2.83-1.41-1.41L38.59 0H40v1.41zM20 18.6l2.83-2.83 1.41 1.41L21.41 20l2.83 2.83-1.41 1.41L20 21.41l-2.83 2.83-1.41-1.41L18.59 20l-2.83-2.83 1.41-1.41L20 18.59z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }

    &:nth-of-type(3) {
        background-image: url("data:image/svg+xml,%3Csvg width='52' height='26' viewBox='0 0 52 26' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Cpath d='M10 10c0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4v2c-3.314 0-6-2.686-6-6 0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6zm25.464-1.95l8.486 8.486-1.414 1.414-8.486-8.486 1.414-1.414z' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    }

    &:nth-of-type(4) {
        background-image: url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 18c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm48 25c3.866 0 7-3.134 7-7s-3.134-7-7-7-7 3.134-7 7 3.134 7 7 7zm-43-7c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm63 31c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM34 90c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zm56-76c1.657 0 3-1.343 3-3s-1.343-3-3-3-3 1.343-3 3 1.343 3 3 3zM12 86c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm28-65c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm23-11c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-6 60c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm29 22c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zM32 63c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm57-13c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-9-21c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM60 91c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM35 41c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2zM12 60c1.105 0 2-.895 2-2s-.895-2-2-2-2 .895-2 2 .895 2 2 2z' fill='%23ffffff' fill-opacity='0.1' fill-rule='evenodd'/%3E%3C/svg%3E");
    }

    &:nth-of-type(5) {
        background-image: url("data:image/svg+xml,%3Csvg width='100' height='20' viewBox='0 0 100 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M21.184 20c.357-.13.72-.264 1.088-.402l1.768-.661C33.64 15.347 39.647 14 50 14c10.271 0 15.362 1.222 24.629 4.928.955.383 1.869.74 2.75 1.072h6.225c-2.51-.73-5.139-1.691-8.233-2.928C65.888 13.278 60.562 12 50 12c-10.626 0-16.855 1.397-26.66 5.063l-1.767.662c-2.475.923-4.66 1.674-6.724 2.275h6.335zm0-20C13.258 2.892 8.077 4 0 4V2c5.744 0 9.951-.574 14.85-2h6.334zM77.38 0C85.239 2.966 90.502 4 100 4V2c-6.842 0-11.386-.542-16.396-2h-6.225zM0 14c8.44 0 13.718-1.21 22.272-4.402l1.768-.661C33.64 5.347 39.647 4 50 4c10.271 0 15.362 1.222 24.629 4.928C84.112 12.722 89.438 14 100 14v-2c-10.271 0-15.362-1.222-24.629-4.928C65.888 3.278 60.562 2 50 2 39.374 2 33.145 3.397 23.34 7.063l-1.767.662C13.223 10.84 8.163 12 0 12v2z' fill='%23ffffff' fill-opacity='0.1' fill-rule='evenodd'/%3E%3C/svg%3E");
    }
}

#overlay {
    display: none;
    width: 120vw;
    height: 1200vh;
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    z-index: 100;
    transform: translateX(-20vw);
}

</style>
